import { createRef, type ReactElement } from 'react';
import { useNavigate } from 'react-router';
import type { MultiLang } from '../../config';
import Functions from '../../functions';
import D3ForumUtils, { type D3ForumCategoryData } from './D3ForumUtils';

interface Props {
    lang: MultiLang;
    name: string;
    catId: number;
}

const CategoryJump = (props: Props) => {
    const { lang, name, catId } = props;
    const navigate = useNavigate();
    const LABEL_TOP = Functions.mlang('[en]Top[/en][ja]トップ[/ja]', lang);
    const LABE_SUBMIT = Functions.mlang('[en]Jump to a category[/en][ja]カテゴリージャンプ[/ja]', lang);
    const catSelect = createRef<HTMLSelectElement>();
    const catSelectOptions: ReactElement[] = [
        <option key="0" value="0">
            ({LABEL_TOP})
        </option>,
    ];
    const catSelectLoop = (categories: D3ForumCategoryData[]) => {
        categories.forEach((category) => {
            const title = Functions.mlang(category.cat_title, lang);
            const depth = category.cat_depth_in_tree !== 0 ? `${'--'.repeat(category.cat_depth_in_tree)} ` : '';
            catSelectOptions.push(
                <option key={category.cat_id} value={category.cat_id}>
                    {depth}
                    {title}
                </option>
            );
            catSelectLoop(D3ForumUtils.getSubCategories(name, category.cat_id));
        });
    };
    catSelectLoop(D3ForumUtils.getCategories(name));
    return (
        <form
            className="d3f_form"
            onSubmit={(e) => {
                e.preventDefault();
                if (catSelect.current !== null) {
                    const selected = Number.parseInt(catSelect.current.value, 10);
                    const url =
                        selected === 0 ? D3ForumUtils.getIndexUrl(name) : D3ForumUtils.getCategoryUrl(name, selected);
                    navigate(url);
                }
            }}
        >
            <select ref={catSelect} defaultValue={String(catId)}>
                {catSelectOptions}
            </select>
            <input type="submit" value={LABE_SUBMIT} />
        </form>
    );
};

export default CategoryJump;
